import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray, FormControl } from '@angular/forms';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { MemberShort, MemberShort2 } from '@app/models/member';
import { Subscription, Observable } from 'rxjs';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { SelectedSign } from '@app/models/selectedsign';
import { Sort } from '@angular/material/sort';
import { MemberService } from '@app/services/member.service';
import { Enumroles } from '@app/models/enumroles.enum';
import { ClaimsService } from '@app/services/claims/claims.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { SortService } from '@app/components/sorting/SortService';
import { ActivatedRoute } from '@angular/router';
import { MembershipService } from '@app/services/membership.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { SelectItem } from 'primeng/api';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-uppdrag',
  templateUrl: './uppdrag.component.html',
  styleUrls: ['./uppdrag.component.css']
})
export class UppdragComponent implements OnInit, OnDestroy {
  minmaxyear = { minYear: '1920', maxYear: '9999' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  incoming_memberid;
  valid = false;
  members: MemberShort2[] = [];
  selectedmembers: MemberShort[] = [];
  offices: any[] = [];
  added = 0;
  responseinfo: string[] = [];
  memberids: number[] = [];
  useraccess;
  selectedmember: MemberShort;
  baseinfo;
  showFilteredList = false;
  selectedSigns: SelectedSign[] = [];
  isClerk = false;
  isSysAdmin = false;
  institutionslist: SelectItem[] = [];
  subscriptions: Subscription[] = [];
  selectedinstitutions: any[] = [];
 form;
  
  type;
  memberships;
  myControl = new FormControl();
  data: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  searchselectedinstitution: any;
  searchselectedinstitutionname: string;
  activememberships;
  institutionlist: LodgeAndCamp[] = [];
  institutions: LodgeAndCamp[] = [];
  selectedSignsForm: FormGroup;
  items: FormArray;
  currentinstitution;
  // tslint:disable-next-line:max-line-length
  constructor(
    private permissionsService: PermissionsService,
    private membershipService: MembershipService,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,
    private snackbarService: SnackbarService,
    private institutionsService: InstitutionsService,
    private memberService: MemberService,
    private fb: FormBuilder,
    private memberofficeService: MemberofficeService) {
    this.permissionsService.selectedrole.subscribe(resp => {
      this.useraccess = resp;
    });

    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      this.baseinfo = data;
      if (data) {
        this.listClaims();
      }
    }));
  }

  setOnlyActive(element) {
    this.form.patchValue({ IncludeNonCurrentInstitutions: element.checked });
  }

  addOffices() {
    this.memberids = [];
    this.responseinfo = [];
    let antal = 0;
    this.added = 0;
    if (this.form.get('institutionId').value) {
      this.selectedSignsForm.controls.items.value.forEach(element => {
        element.institutionId = this.form.get('institutionId').value;
      });
    }
    antal = this.selectedSignsForm.controls.items.value.length;
    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      if (this.form.get('officeInstitutionId').value) {
        this.selectedSignsForm.controls.items.value.forEach(element => {
          element.institutionId = this.form.get('officeInstitutionId').value;
        });
      }
    }

    this.subscriptions.push(this.memberofficeService.UpdateMemberOffice(this.selectedSignsForm.controls.items.value).subscribe(response => {
      let idx = 0;
      response.forEach(item => {
        let memberid;
        this.responseinfo.push(item.status);
        if (this.selectedSignsForm.controls.items.value[idx]) {
          memberid = this.selectedSignsForm.controls.items.value[idx].memberId;
        }
        if (item.rowsAffected !== 0) {
          this.added++;
          this.memberids.push(memberid);
          this.memberService.timestamp.next(+new Date());
        }
        idx++;
      });
      this.snackbarService.openSnackBar(this.added + ' av ' + antal + ' uppdrag/ämbeten tillagda', null);
      this.memberids.forEach(memberid => {
        this.uncheckMember(memberid);
      });
      this.memberids.forEach(memberid => {
        this.removeAddedRow(memberid);
      });
      this.memberids.forEach(memberid => {
        this.removeSelectedMember(memberid);
      });
    }));
  }

  addOffice() {
    this.selectedmember = null;
  }

  ngOnInit() {
    this.form = this.fb.group({
      memberId: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      institutionId: ['', ''],
      officeInstitutionId: ['', ''],
      IncludeNonCurrentInstitutions: [false, '']
    });
    
    this.route.queryParams.subscribe(qParam => {
      this.members = [];
      this.responseinfo = [];
      if (qParam.type === 'member') {
        this.form.patchValue({ memberId: qParam.memberid });
        this.searchForSpecificMember(qParam.memberid);
        this.checkMember(qParam.memberid);
        if (this.useraccess?.userPermissionLevel === "SY" && this.useraccess?.permissions.indexOf('CAN_MAKE_EXCEPTIONS') > -1) {
          this.membershipService.getFakeMembershipByMemberIdForException(qParam.memberid).subscribe(memberships => {
            if (memberships) {
              this.memberships = memberships;
            }
          }
          );
        } else if (qParam.type === 'member') {
          this.type = 'member';
          this.membershipService.getMembershipByMemberId(qParam.memberid).subscribe(memberships => {
            if (memberships) {
              this.memberships = memberships;
              if (this.useraccess?.roleId !== 13 && this.useraccess?.userDomain !== 'GENERAL') {
                this.memberships = this.memberships.filter(m => m.endDate.startsWith('9999'));
              }
              if (this.useraccess?.userPermissionLevel === 'IN') {
                this.memberships = this.memberships.filter(m => m.endDate.startsWith('9999') && m.institutionId === this.useraccess?.institution.id);
              }
            }
          }
          );
        }
      }

      if (qParam.type === 'institution') {
        this.type = 'institution';
        this.institutionsService.getInstitutionByIdAsync(qParam.id).subscribe(x => {
          this.currentinstitution = x;
          if (this.useraccess?.roleId === 12 || this.useraccess?.roleId === 13) {
            this.selectedinstitutionname = this.currentinstitution.shortName + ' - ' + this.currentinstitution.name;
            this.selectedinstitution = this.currentinstitution;
          }
          this.form.patchValue({ institutionId: x.id.toString(), officeInstitutionId: this.currentinstitution.id });
          this.getPossibleOffices(this.currentinstitution.id);
        });
      }
    }
    );
    this.selectedSignsForm = this.fb.group({
      items: this.fb.array([])
    });
    this.getAllInstitutions();

    if (this.claimsService.isClerk() || this.claimsService.isSysAdmin()) {
      this.isClerk = this.claimsService.isClerk();
      this.isSysAdmin = this.claimsService.isSysAdmin();
      this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
        data.forEach(element => {
          const inst = { id: element.id, shortName: element.shortName, name: element.name };
          this.data.push(inst);

        });
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith<string | LodgeAndCamp>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.data.slice())
          );
      }));
    }
    this.populateOffices();
  }

  getAllInstitutions() {
    this.institutionsService.getInstitutions().subscribe(response => {
      this.institutions = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutions.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutions = this.institutions.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      this.institutionslist = [];
      if (this.institutions) {
        this.institutions.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.institutionslist.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.institutionslist.unshift(emptyrecord);
      }
    });
  }

  clear() {
    this.myControl.setValue(null);
    this.members = [];
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getOffices() {
    this.getPossibleOffices(Number(this.form.get('institutionId').value));
  }

  getPossibleOffices(institutionId: number) {
    if (institutionId === 0) {
      this.offices = [];
    } else {
      this.subscriptions.push(this.memberofficeService.GetPossibleOffices(institutionId).subscribe(data => {
        this.offices = data;
      }));
    }
  }

  setOfficeCommitteeId(evt) {
    const idx = this.selectedSignsForm.controls.items.value.findIndex(x => {
      return x.memberId = evt;
    });
    this.selectedSignsForm.controls.items.value[idx].officeCommitteeId
  }

  listClaims() {
    this.institutionlist = [];
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.ADMIN_LODGE || element.key === Enumroles.ADMIN_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });
  }

  createItem(member: MemberShort, element: any): FormGroup {
    return this.fb.group({
      memberId: member.id,
      institutionId: this.form.get('institutionId').value,
      givenName: member.givenName,
      familyName: member.familyName,
      officeCommitteeId: ['', Validators.required],
      action: 'add',
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });
  }

  addItem(member: MemberShort, element: any): void {
    this.items = this.selectedSignsForm.get('items') as FormArray;
    this.items.push(this.createItem(member, element));
  }

  search() {
    this.responseinfo = [];
    this.subscriptions.push(this.memberService.SearchMemberForOfficesAndSigns(this.form.value).subscribe(data => {
      this.members = data;
    }));
  }

  searchForSpecificMember(memberid) {
    this.subscriptions.push(this.memberService.SearchMemberForOfficesAndSigns(this.form.value).subscribe(data => {
      this.members = data;
      this.selectedmembers.push(this.members[0]);
      this.form.patchValue({ givenName: data[0]?.givenName, familyName: data[0]?.familyName });
      this.checkMember(memberid);
    }));
  }

  validate(evt: any) {
    if (evt.target.value !== null) {
      this.valid = true;
    } else {
      this.valid = false;
    }
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item?.id === memberid);
  }

  uncheckMember(memberid: number) {
    const idx = this.members.findIndex(item => item.id === memberid);
    if (this.members[idx]) {
      this.members[idx].checked = false;
    }
  }

  add(selectedmember, element) {
    if (element.checked) {
      this.addItem(selectedmember, element);
      this.selectedmembers.push(selectedmember);
      this.filterList(selectedmember.id);
      this.members[this.members.findIndex(item => item.id === selectedmember.id)].checked = true;
    } else {
      this.removeFromArray(selectedmember.id);
      this.filterListById(selectedmember.id);
      this.removeSelectedMember(selectedmember.id);
    }
    this.selectedmember = selectedmember;
  }

  removeSelectedMember(id: number) {
    const elementidx = this.selectedmembers.findIndex(obj => obj?.id === id);
    this.selectedmembers.splice(elementidx, 1);
    this.uncheckMember(id);
  }

  filterList(id: number) {
    const sign = { memberId: id, id: null, date: null };
    this.selectedSigns.push(sign);
    this.showFilteredList = true;
  }

  filterListById(id: number) {
    const signidx = this.selectedSigns.findIndex(obj => obj.memberId === id);
    this.selectedSigns.splice(signidx, 1);
  }

  removeAddedRow(id: number) {
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === id));
  }

  removeAddedReposeInfo(id: number) {
    const respidx = this.responseinfo.findIndex(memberid => Number(memberid) === id);
    this.responseinfo.splice(respidx, 1);
  }

  removeFromArray(memberid: number) {
    const idx = this.members.findIndex(item => item.id === memberid);
    this.members[idx].checked = false;
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === memberid));
  }

  sortData(sort: Sort) {
    const data = this.members.slice();
    if (!sort.active || sort.direction === '') {
      this.members = data;
      return;
    }
    this.members = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.data.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  displayFn(user?: LodgeAndCamp): string | undefined {
    return user ? user.shortName + ' ' + user.name : undefined;
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.clearSelectedSignsForm();
    this.selectedinstitution = event.option.value.id;
    this.form.get('institutionId').setValue(event.option.value.id);
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
  }

  institutionSelected(evt) {
    this.selectedinstitution = evt.value.id;
    this.form.get('officeInstitutionId').setValue(evt.value.id);
    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      this.getPossibleOffices(evt.value.id);
    }
    this.selectedinstitutionname = evt.value.name;
  }

  searchInstitutionSelected(evt) {
    this.clearSelectedSignsForm();
    this.searchselectedinstitution = evt.value.id;
    this.searchselectedinstitutionname = evt.value.name;
  }

  populateOffices() {
    const institutionid = this.currentinstitution?.id;
    this.clearSelectedSignsForm();
    this.selectedinstitution = institutionid;
    this.form.get('institutionId').setValue(institutionid);
    this.selectedinstitutionname = this.currentinstitution?.name;
  }

  clearSelectedSignsForm() {
    const controllength = this.selectedSignsForm.controls.items.value.length;
    for (const c of this.selectedSignsForm.controls.items.value) {
      this.removeFromArray(c.memberId);
    }
    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      this.members = [];
    }
  }

  get memberId() {
    return this.form.get('memberId').value;
  }

  get givenName() {
    return this.form.get('givenName').value;
  }

  get familyName() {
    return this.form.get('familyName').value;
  }

}
